import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "toggle", "copy", "copyLabel"]

  disconnect() {
    clearTimeout(this.copyResetTimer)
  }

  toggle() {
    const shouldReveal = this.fieldTarget.type === "password"
    const label = shouldReveal ? "Скрыть временный пароль" : "Показать временный пароль"

    this.fieldTarget.type = shouldReveal ? "text" : "password"
    this.toggleTarget.title = label
    this.toggleTarget.setAttribute("aria-label", label)

    const icon = this.toggleTarget.querySelector("[data-secret-icon]")
    if (icon) {
      icon.classList.toggle("fa-eye", !shouldReveal)
      icon.classList.toggle("fa-eye-slash", shouldReveal)
    }
  }

  async copy() {
    try {
      await this.writeToClipboard(this.fieldTarget.value)
      this.showCopyStatus("Скопировано")
    } catch (_error) {
      this.showCopyStatus("Не скопировано")
    }
  }

  writeToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text)
    }

    return Promise.resolve(this.copyWithFallback(text))
  }

  copyWithFallback(text) {
    const temporaryField = document.createElement("textarea")
    temporaryField.value = text
    temporaryField.setAttribute("readonly", "")
    temporaryField.style.position = "fixed"
    temporaryField.style.opacity = "0"
    document.body.appendChild(temporaryField)
    temporaryField.select()

    const copied = document.execCommand("copy")
    temporaryField.remove()

    if (!copied) throw new Error("Clipboard copy failed")
  }

  showCopyStatus(status) {
    clearTimeout(this.copyResetTimer)
    this.copyLabelTarget.textContent = status
    this.copyTarget.setAttribute("aria-label", status)

    this.copyResetTimer = setTimeout(() => {
      this.copyLabelTarget.textContent = "Скопировать"
      this.copyTarget.setAttribute("aria-label", "Скопировать временный пароль")
    }, 2000)
  }
}
